function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ClosingScheduleIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29 14H16v-4h3c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1h-8c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h3v4H1c-.6 0-1 .4-1 1s.4 1 1 1h5v4H3c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1H8v-4h14v4h-3c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-3v-4h5c.6 0 1-.4 1-1s-.4-1-1-1zM12 2h6v6h-6V2zm-2 26H4v-6h6v6zm16 0h-6v-6h6v6z"
  }));
};
export default ClosingScheduleIcon;